import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { OrderPrestadorService } from 'src/app/services/order-prestador.service';
import { OrdenPrestador } from 'src/app/models/OrdenPrestador';
import { AuthService } from 'src/app/services/auth.service';
import { API_URI } from 'src/environments/environment';
import { LoadingService } from 'src/app/services/loading.service';
import { firstValueFrom } from 'rxjs';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
    selector: 'app-order-confirm-prestador',
    templateUrl: './order-confirm-prestador.component.html',
    styleUrls: ['./order-confirm-prestador.component.css'],
    standalone: false
})
export class OrderConfirmPrestadorComponent {
  private _authService = inject(AuthService);
  private _orderPrestadorService = inject(OrderPrestadorService);
  private _usuarioService = inject(UsuarioService);
  private _loadingService = inject(LoadingService);
  private _router = inject(Router);
  private _aRoute = inject(ActivatedRoute);
  private _location = inject(Location);

  error = signal<string>('');
  loadingGlobal = computed(() => this._loadingService.isLoading());
  loadingLocal = signal<boolean>(false);

  id_solicitud: string = this._aRoute.snapshot.paramMap.get('id_solicitud') ?? '';
  ordenesPrestador = signal<OrdenPrestador[]>([]);
  API_URI: string = API_URI;

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();

        if (this._authService.session() === 'guest') {
          this._router.navigate(['/sign-in']);
          return;
        }

        if (!this.id_solicitud) {
          this._router.navigate(['/dashboard']);
          return;
        }

        const perfil = this._usuarioService.usuario().id_perfil;

        if (perfil === 3) {
          this._router.navigate(['/order-response-prestador/' + this.id_solicitud]);
          return;
        }

        const resOrdenes = await firstValueFrom(
          this._orderPrestadorService.getOrdenesPrestadorXSolicitud(this.id_solicitud)
        );

        if (!resOrdenes || resOrdenes.length === 0) {
          this._router.navigate(['/dashboard']);
          return;
        }

        this.ordenesPrestador.set(resOrdenes);
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this._router.navigate(['/sign-in']);
      }
    });
  }

  async pagarOrderPrestador(ordenPrestador: OrdenPrestador, d_fecha_turno: Date | null | undefined): Promise<void> {
    this.error.set('');
    this.loadingLocal.set(true);

    try {
      if (!ordenPrestador || !d_fecha_turno) {
        this.error.set('Ups, ha ocurrido un error.');
        return;
      }
      // Genero Pago en MercadoPago
      ordenPrestador.d_fecha_turno = d_fecha_turno;
      const ordenPrestadorMP = { ...ordenPrestador };
      const resPagarMP = await firstValueFrom(this._orderPrestadorService.pagarMercadoPago(ordenPrestadorMP));

      // Si salio bien e pago actualizo la orden de prestador a PROCESANDO PAGO
      ordenPrestador.id_estado_orden = 7; // PROCESANDO PAGO
      const ordenPrestadorUpdate = { ...ordenPrestador };
      await firstValueFrom(this._orderPrestadorService.updateOrdenPrestador(ordenPrestadorUpdate));

      window.open(resPagarMP, '_self');
    } catch (e: any) {
      if (e?.error?.message) {
        this.error.set('Error al generar el Pago para MercadoPago en la Orden de Prestador: ' + e.error.message);
      } else {
        this.error.set('No se pudo generar el pago.');
      }
      console.error('Error al procesar pago de la Orden de Prestador:', e);
    } finally {
      this.loadingLocal.set(false);
    }
  }

  back(): void {
    this._location.back();
  }

  openFile(): void {
    const x_img_receta = this.ordenesPrestador()[0]?.x_img_receta;
    if (!x_img_receta) return;
    window.open(`${API_URI}uploads/images/${x_img_receta}`, '_blank');
  }

  trackByOrden(index: number, item: OrdenPrestador): number | string {
    return item.id ?? index;
  }
}